var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contacts"},[_c('vue-headful',{attrs:{"title":_vm.page.header.title,"description":_vm.page.header.description,"keywords":_vm.page.header.keywords}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center m-sm-3 m-3"},[_c('h3',{attrs:{"align":"center"}},[_vm._v("Раздел находится в разработке")])])
}]

export { render, staticRenderFns }